import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: false,
})
export class ProgressBarComponent implements OnInit {
  @Input()
  public label: string;
  @Input()
  public percent: string;
  @Input()
  public showDetailsIfZero: string = 'true';
  @Input()
  public showDetailsIfNull: string = 'false';
  @Input()
  public fillColor: string = 'darkred';
  constructor() {}

  ngOnInit(): void {}

  getBarId() {
    return `${this.fillColor}-progress`;
  }

  showRow() {
    return (
      this.showDetailsIfNull !== 'false' ||
      (this.percent && this.showDetailsIfZero !== 'false') ||
      this.getFormattedPercent() > 0
    );
  }

  getFormattedPercent() {
    if (this.percent) {
      const value = +this.percent;
      return Math.round(value * 100);
    }
    return 0;
  }
  getProgressValue() {
    return 100 - this.getFormattedPercent();
  }
}
